var _regeneratorRuntime = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var BaseFilter = require('./base-filter');

var getBlocksForRange = require('./getBlocksForRange');

var _require = require('./hexUtils'),
    incrementHexInt = _require.incrementHexInt;

var TxFilter = /*#__PURE__*/function (_BaseFilter) {
  "use strict";

  _inherits(TxFilter, _BaseFilter);

  var _super = _createSuper(TxFilter);

  function TxFilter(_ref) {
    var _this;

    var provider = _ref.provider;

    _classCallCheck(this, TxFilter);

    _this = _super.call(this);
    _this.type = 'tx';
    _this.provider = provider;
    return _this;
  }

  _createClass(TxFilter, [{
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var oldBlock, toBlock, fromBlock, blocks, blockTxHashes, _iterator, _step, block;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                oldBlock = _ref2.oldBlock;
                toBlock = oldBlock;
                fromBlock = incrementHexInt(oldBlock);
                _context.next = 5;
                return getBlocksForRange({
                  provider: this.provider,
                  fromBlock: fromBlock,
                  toBlock: toBlock
                });

              case 5:
                blocks = _context.sent;
                blockTxHashes = [];
                _iterator = _createForOfIteratorHelper(blocks);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    block = _step.value;
                    blockTxHashes.push.apply(blockTxHashes, _toConsumableArray(block.transactions));
                  } // add to results

                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.addResults(blockTxHashes);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update(_x) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }]);

  return TxFilter;
}(BaseFilter);

module.exports = TxFilter;